import React, {Component} from 'react'
import SearchItemTop from '../SearchItemTop'
import ConfirmBtn from '../ConfirmBtn'
import FunctionsPopup from '../FunctionsPopup'
import commonMethod from "../../lib/commonMethod";


class KeywordSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywordList: null,
            selectedKeyword: [],
            isOpen: props.data.condition === "editing",
            functionsPopup: false,
            loading:true,
        };

    }

    componentDidMount() {
        if((this.props.data.keyword && this.props.data.keyword.length > 0) || this.props.data.isLoad){
            
            this.setState({
                keywordList: this.props.data.keywordAll,
                selectedKeyword: this.props.data.keyword,
                loading:false,
            })

            // this.props.editItem(this.props.data, this.props.data.keyword, this.props.data.keywordAll);
        }else{
            if (this.props.data.condition === "editing"){
                 this.getResult(this.props.data.code)
            }
        }

    }

    componentWillUpdate(props, state) {
        if (!this.state.isOpen && (props.data.condition === "editing" || props.data.condition === "editable") && (props.data.keyword == false || props.data.keyword.length == 0)) {
            this.setState({isOpen: true, selectedKeyword: props.data.keyword});
            this.getResult(this.props.data.code * 1);
        } else if(!this.state.isOpen && (props.data.condition === "editing" || props.data.condition === "editable")){
            this.setState({isOpen: true, selectedKeyword: props.data.keyword});
        } else if (this.state.isOpen && props.data.condition === "complete") {
            this.setState({isOpen: false});
        } else if (this.state.isOpen && props.data.condition === "waiting") {
            this.setState({selectedKeyword: props.data.keyword,isOpen: false,loading:true})
        } else if (this.state.selectedKeyword !== props.data.keyword) {
            this.setState({selectedKeyword: props.data.keyword})
        }
    }


    getResult(code) {
        let searchList = this.props.searchList;
        let data = commonMethod.makeParameter(this.props.userId, this.props.accessToken, code, searchList);
        commonMethod.requestStepSearch('https://d7ecgx9wn9.execute-api.us-west-1.amazonaws.com/step_search', data, res => {
            let keywordList = [];
            if(res.data && typeof res.data == "object" && !res.data.errorMessage){
                res.data.map((item,key) => {
                    if(item !== ""){
                        if(item.wiki_url){
                            keywordList.push({
                                id: key,
                                code:this.props.data.code,
                                name: item.name,
                                wiki_url:item.wiki_url,
                            });
                        }else{

                            if(code == 6){
                                keywordList.push({
                                    id: key,
                                    code:this.props.data.code,
                                    name: item.name,
                                });
                            }else if (code === 2 || code === 3){
                                keywordList.push({
                                    id: key,
                                    code:this.props.data.code,
                                    name: item,
                                });
                            } else if (code == 4) {
                                keywordList.push({
                                    id:key,
                                    code:this.props.data.code,
                                    // name:item
                                })
                            }
                            
                        }
                    }
                });

                this.setState({
                    keywordList: keywordList,
                });

                this.props.editItem(this.props.data, this.state.selectedKeyword, keywordList);
            }

            this.setState({loading:false});
        });
    }

    toggleKeyword(e,data) {
        // console.log(data);
        if(e.target.tagName == "A") return false;

        let condition = this.props.data.condition;

        if (condition === "editing" || condition === "editable") {
            let selectedKeyword = this.state.selectedKeyword ? this.state.selectedKeyword : [];

            let idx = selectedKeyword.findIndex(function (keyword) {
                return keyword.id === data.id
            })

            if (idx > -1) {
                selectedKeyword.splice(idx, 1);
            } else {
                selectedKeyword.push(data);
            }

            this.setState({selectedKeyword: selectedKeyword})
            this.props.editItem(this.props.data, selectedKeyword, this.state.keywordList);
        }

    }

    confirm() {

        if (this.state.selectedKeyword.length !== 0) {

            this.props.addSearchKeyword(this.state.selectedKeyword);
        }
    }

    addFunctions(functions) {

        let selectedKeyword = this.state.selectedKeyword;
        let keywordList = this.state.keywordList;

        keywordList.push(functions);
        selectedKeyword.push(functions);

        

        this.setState({
            selectedKeyword: selectedKeyword,
            functionsPopup: false,
            keywordList: keywordList,
        });
        this.props.editItem(this.props.data, selectedKeyword, keywordList);
    }

    render() {
        let keywordList = this.state.keywordList;
        let data = this.props.data;
        return (
            <div id={data.id} className={data.condition === "waiting" ?
                "search-item-wrap related-keyword movable" : "search-item-wrap related-keyword"}>
                <SearchItemTop addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                               data={this.props.data} isOpen={this.state.isOpen}
                               keywordList={this.state.selectedKeyword}
                               setIsOpen={(isOpen) => this.setState({isOpen: isOpen})}
                               deleteItem={() => this.props.deleteItem()}
                               libraryList={this.props.libraryList}/>

                {(this.state.isOpen || data.condition === "editing") &&
                <React.Fragment>
                    {!this.state.loading ?
                        (keywordList && keywordList.length !== 0) ?
                    <ul className="keyword-list">
                        {keywordList.map((v, k) => {

                            let selectedKeyword = this.state.selectedKeyword;
                            let isExist = selectedKeyword && selectedKeyword.findIndex(keyword => keyword.id === v.id) !== -1 ? true : false;

                            return <li key={k} className={isExist ? "active" : ""}
                                       onClick={(e) => this.toggleKeyword(e,v)}>
                                <span>{v.name}</span>
                                 {v.wiki_url && v.wiki_url !== "NONE" && <a className="detail-keyword"
                                                    href={v.wiki_url} target="_blank">i</a>}
                            </li>
                        })}
                        {/* Functions add */}
                        {(data.type === "Functions" && (data.condition === "editing" || data.condition === "editable")) &&
                        <li className="functions-add"
                            onClick={() => this.setState({functionsPopup: true})}>
                            + Add an action & object
                        </li>}
                    </ul>
                        : <p className="no_result_text">No search results found.</p>
                    : <p className="no_result_text">loading..</p>}

                    {(data.condition !== "complete" && data.condition !== "editable") &&
                    <ConfirmBtn
                        isConfirm={this.props.beforeItem ? this.props.beforeItem.keyword && this.state.selectedKeyword && this.props.beforeItem.keyword.length !== 0 && this.state.selectedKeyword.length !== 0 : this.state.selectedKeyword.length !== 0}
                        onClick={() => this.confirm()}/>
                    }

                </React.Fragment>
                }

                {/* Functions Popup */}
                {this.state.functionsPopup &&
                <FunctionsPopup onClose={() => this.setState({functionsPopup: false})}
                                addFunctions={(keyword) => this.addFunctions(keyword)}/>}
            </div>
        )
    }
}


export default KeywordSearch; 

